import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from './AuthContext';

const SocketContext = createContext();

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocket muss innerhalb von SocketProvider verwendet werden');
  }
  return context;
};

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [connected, setConnected] = useState(false);
  const { token, user } = useAuth();

  useEffect(() => {
    if (token && user) {
      // Socket.io Verbindung erstellen
      const newSocket = io(process.env.REACT_APP_API_URL || 'https://api.dstools.at', {
        auth: {
          token: token
        }
      });

      newSocket.on('connect', () => {
        console.log('Socket.io verbunden');
        setConnected(true);
      });

      newSocket.on('disconnect', () => {
        console.log('Socket.io getrennt');
        setConnected(false);
      });

      newSocket.on('connect_error', (error) => {
        console.error('Socket.io Verbindungsfehler:', error);
        setConnected(false);
      });

      setSocket(newSocket);

      return () => {
        newSocket.close();
        setSocket(null);
        setConnected(false);
      };
    }
  }, [token, user]);

  // Tab-Events
  const subscribeToSOS = (sosId) => {
    if (socket) {
      socket.emit('subscribe_sos', sosId);
    }
  };

  const unsubscribeFromSOS = (sosId) => {
    if (socket) {
      socket.emit('unsubscribe_sos', sosId);
    }
  };

  // Event-Listener für Tab-Updates
  const onTabConfirmed = (callback) => {
    if (socket) {
      socket.on('tab_confirmed', callback);
      return () => socket.off('tab_confirmed', callback);
    }
  };

  const onTabsRemoved = (callback) => {
    if (socket) {
      socket.on('tabs_removed', callback);
      return () => socket.off('tabs_removed', callback);
    }
  };

  const onNewSOS = (callback) => {
    if (socket) {
      socket.on('new_sos', callback);
      return () => socket.off('new_sos', callback);
    }
  };

  const onSyncStatus = (callback) => {
    if (socket) {
      socket.on('sync_status', callback);
      return () => socket.off('sync_status', callback);
    }
  };

  const onAdminMessage = (callback) => {
    if (socket) {
      socket.on('admin_message', callback);
      return () => socket.off('admin_message', callback);
    }
  };

  const value = {
    socket,
    connected,
    subscribeToSOS,
    unsubscribeFromSOS,
    onTabConfirmed,
    onTabsRemoved,
    onNewSOS,
    onSyncStatus,
    onAdminMessage
  };

  return (
    <SocketContext.Provider value={value}>
      {children}
    </SocketContext.Provider>
  );
};
